










































































import moment = require('moment');
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { defaultCipherList } from 'constants';
// import { Moment, isMoment } from 'moment';

@Component({
  name: 'ui-date-picker',
})
export default class UiDatePicker extends Vue {
  @Prop({ type: Date, default: () => new Date() }) value: Date;
  @Prop({ type: Date, default: () => new Date() }) dateSecond: Date;
  @Prop({ type: Boolean, default: true }) asUTC: boolean;
  @Prop({ default: 'DD.MM.YYYY', type: String }) dateFormat: string;
  // ограничение даты снизу
  @Prop({ default: null, type: Date }) minimumDate: Date;
  @Prop({ default: null, type: Date }) maximumDate: Date;

  @Prop({ type: String }) initialView: String;
  @Prop({ default: 'months', type: String }) minimumView: string;
  @Prop({ default: 'years', type: String }) maximumView: string;

  //включен диапазон дат
  @Prop({ default: false, type: Boolean }) isDateRange: boolean;
  @Prop({ default: false, type: Boolean }) view2: boolean;

  // показывать текущую дату
  @Prop({ default: true, type: Boolean }) showCurrentDate: boolean;

  //показывать рамку только активации элемента
  @Prop({ default: false, type: Boolean }) transformer: boolean;

  @Prop({ default: null }) eventDates: Array<any>;
  @Prop({ default: true, type: Boolean }) autoCloseWhenChangeDay: boolean; //закрывать после выбора дня месяца
  @Prop({ default: false, type: Boolean }) changeDateManual: boolean; //разрешить редактирование даты вручную
  @Prop({ default: false, type: Boolean }) letSelectAllDays: boolean;

  innerDate = this.value;
  innerDateFormatted = this.formatDate(this.value);
  innerSecondDate = this.dateSecond;
  innerSecondDateFormatted = this.formatDate(this.dateSecond);
  inner2DateFormatted: { dateFrom: Date; dateTo: Date } = {
    dateFrom: this.innerDateFormatted,
    dateTo: this.innerSecondDateFormatted,
  };

  innerShowDatetime = false;
  isFirstChoice = true;
  iconFocused = false;
  firstClick = true;

  @Watch('innerShowDatetime')
  onInnerShowDatetime() {
    this.iconFocused = this.innerShowDatetime;
  }
  created() {
    document.body.addEventListener('click', this.clickOutside.bind(this));
  }
  destroyed() {
    document.body.removeEventListener('click', this.clickOutside.bind(this));
  }

  @Watch('value')
  onChangeDate() {
    this.innerDate = this.value;
    this.innerDateFormatted = this.formatDate(this.value);
  }

  // @Watch("innerDate")
  // onInnerDate(){
  //    this.$emit("input", this.getFormatDate(this.innerDate));
  // }

  @Watch('innerDateFormatted')
  @Watch('innerSecondDateFormatted')
  oninnerDateFormatted() {
    if (this.isDateRange) {
      if (this.view2) {
        this.inner2DateFormatted = {
          dateFrom: this.formatDate(this.innerDate),
          dateTo: this.formatDate(this.innerSecondDate),
        };
      }
      this.$emit('inputrange', this.getFormatDate(this.innerDate), this.getFormatDate(this.innerSecondDate));
    } else {
      this.$emit('input', this.getFormatDate(this.innerDate));
      if (this.changeDateManual) {
        return;
      }

      var x = this.formatDateRev(this.innerDateFormatted);
      if (x != 'Invalid Date') {
        this.innerDate = x;
      } else this.innerDateFormatted = this.formatDate(this.innerDate);

      this.$emit('input', this.getFormatDate(this.innerDate));
    }
  }

  getFormatDate(date: Date): Date {
    if (!this.asUTC) {
      return date;
    }
    var now_utc = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
    return new Date(now_utc);
  }

  //--------------------------------------------
  changeDate(date: Date, type: string) {
    if (this.isDateRange) {
      if (this.isFirstChoice) {
        this.changeFirstDate(date);
      } else {
        if (this.innerDate > date) {
          let swap = this.innerDate;
          this.innerDate = date;
          this.innerDateFormatted = this.formatDate(this.innerDate);
          date = swap;
          this.innerSecondDate = date;
          this.innerSecondDateFormatted = this.formatDate(this.innerSecondDate);
          this.changeFirstDate(this.innerDate);
          this.isFirstChoice = !this.isFirstChoice;
          if (this.autoCloseWhenChangeDay && type == 'days') {
            this.innerShowDatetime = false;
          }
          return;
        }
        this.changeSecondDate(date);
      }
      this.isFirstChoice = !this.isFirstChoice;
    } else {
      this.changeFirstDate(date);
    }
    if (this.autoCloseWhenChangeDay && this.isFirstChoice && type == 'days') {
      this.innerShowDatetime = false;
    }
  }

  changeFirstDate(date: Date) {
    this.innerDate = date;
    this.innerDateFormatted = this.formatDate(this.innerDate);
    this.$emit('inputRage', this.getFormatDate(this.innerDate), this.getFormatDate(this.innerSecondDate));
  }

  changeSecondDate(date: Date) {
    this.innerSecondDate = date;
    this.innerSecondDateFormatted = this.formatDate(this.innerSecondDate);
    this.$emit('inputRage', this.getFormatDate(this.innerDate), this.getFormatDate(this.innerSecondDate));
  }

  targetDatetime() {
    this.innerShowDatetime = !this.innerShowDatetime;
    this.iconFocused = this.innerShowDatetime;
  }
  formatDate(date: Date) {
    var moment = require('moment');
    var now = moment(date);
    moment.lang('ru');
    return now.format(this.dateFormat);
  }
  formatDateRev(value: String) {
    var moment = require('moment');
    var now = moment(value, this.dateFormat);
    moment.lang('ru');
    return now.toDate();
  }

  isClickedToDatePicker(event: MouseEvent): boolean {
    // const box = this.$refs.dateTimeWrapper as HTMLElement;
    const boxId = document.getElementById('dateTimeWrapper');
    if (!boxId) {
      return false;
    }
    const rect = boxId.getBoundingClientRect();
    if (!rect) {
      return false;
    }
    const dx = event.clientX - rect.left;
    const dy = event.clientY - rect.top;
    return dx > 0 && dx < rect.width && dy > 0 && dy < rect.height;
  }

  clickOutside(event: any) {
    if (this.isClickedToDatePicker(event)) {
      if (this.isDateRange) {
        // this.isFirstChoice = true;
        // if (this.isFirstChoice && this.innerDate > this.innerSecondDate) {
        //   var k = this.innerDate;
        //   this.changeFirstDate(this.innerSecondDate);
        //   this.changeSecondDate(k);
        // }
      }
    } else {
      if (!(this.$el == event.target || this.$el.contains(event.target))) {
        if (this.innerShowDatetime) {
          this.innerShowDatetime = false;
        }
      }
    }
  }
  onPressEnterLeft() {
    if (moment(this.inner2DateFormatted.dateFrom, 'DD.MM.YYYY')._isValid) {
      this.innerDate = moment(this.inner2DateFormatted.dateFrom, this.dateFormat)._d;
      this.oninnerDateFormatted();
    } else {
      this.inner2DateFormatted.dateFrom = this.formatDate(this.innerDate);
    }
  }
  onPressEnterRight() {
    if (moment(this.inner2DateFormatted.dateTo, 'DD.MM.YYYY')._isValid) {
      this.innerSecondDate = moment(this.inner2DateFormatted.dateTo, this.dateFormat)._d;
      this.oninnerDateFormatted();
    } else {
      this.inner2DateFormatted.dateTo = this.formatDate(this.innerSecondDate);
    }
  }
  onFocus(el: any) {
    // this.iconFocused = true;
    // if (this.changeDateManual){

    //       this.innerShowDatetime = false
    // }
    // else{
    //   this.targetDatetime()

    // }
    this.innerShowDatetime = true;
  }
  onEnter(el: any) {
    if (this.changeDateManual) {
      if (moment(this.innerDateFormatted, this.dateFormat).isValid()) {
        var now = moment(this.innerDateFormatted, this.dateFormat);
        this.innerDate = now.toDate();
      }
    }
    el.target.blur();
    this.innerShowDatetime = false;
    this.iconFocused = false;
  }
  onTab(el: any) {
    if (this.changeDateManual) {
      if (moment(this.innerDateFormatted, this.dateFormat).isValid()) {
        var now = moment(this.innerDateFormatted, this.dateFormat);
        this.innerDate = now.toDate();
        this.$emit('input', this.getFormatDate(this.innerDate));
      } else {
        this.innerDateFormatted = this.formatDate(this.innerDate);
      }
    }
    el.target.blur();
    this.innerShowDatetime = false;
    this.iconFocused = false;
  }

  onBlur(el: any) {
    if (this.changeDateManual) {
      if (moment(this.innerDateFormatted, this.dateFormat).isValid()) {
        var now = moment(this.innerDateFormatted, this.dateFormat);
        this.innerDate = now.toDate();
        this.$emit('input', this.getFormatDate(this.innerDate));
      } else {
        this.innerDateFormatted = this.formatDate(this.innerDate);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-date-picker/src/ui-date-picker.vue